import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Star } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { ukDate } from '../../lib/format';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Staff see their own score, reliability and the comments customers left
export const MyRatingCard = ({ token }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/staff/my-ratings`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setData(res.data))
      .catch(() => setData(null));
  }, [token]);

  if (!data) return null;

  return (
    <Card className="bg-white bd-card-accent" data-testid="my-rating-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <Star className="h-5 w-5 text-gold-deep" /> My rating
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-wrap gap-3">
          <div className="flex-1 rounded-[10px] border border-gold bg-cream p-3">
            <p className="text-[11px] font-semibold text-slate-500">Customer stars</p>
            <p className="mt-1 text-2xl font-extrabold text-ink" data-testid="my-score">
              {data.score.stars ? `${data.score.stars.toFixed(1)} ★` : 'No ratings yet'}
              {data.score.stars ? (
                <span className="ml-1 text-sm font-semibold text-slate-500">
                  ({data.score.count} job{data.score.count === 1 ? '' : 's'})
                </span>
              ) : null}
            </p>
          </div>
          <div className="flex-1 rounded-[10px] border border-hair bg-page p-3">
            <p className="text-[11px] font-semibold text-slate-500">Reliability</p>
            <p className="mt-1 text-2xl font-extrabold text-ink" data-testid="my-reliability">
              {data.reliability.score === null ? '—' : `${data.reliability.score}%`}
            </p>
            <p className="text-[11px] text-slate-500">
              Messaging the client, arriving on time and pressing All done
            </p>
          </div>
        </div>

        {data.comments.length === 0 ? (
          <p className="text-sm text-slate-500">
            No customer comments yet. They arrive after your jobs are completed.
          </p>
        ) : (
          <div className="space-y-2">
            {data.comments.slice(0, 8).map((row) => (
              <div key={row.id} className="rounded-[10px] border border-hair bg-page p-3"
                   data-testid={`my-comment-${row.id}`}>
                <div className="flex items-center justify-between gap-2">
                  <span className="flex items-center gap-0.5">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <Star key={n}
                            className={`h-3.5 w-3.5 ${n <= row.stars ? 'fill-gold text-gold' : 'text-slate-300'}`} />
                    ))}
                  </span>
                  <span className="text-[11px] text-slate-500">
                    {ukDate(row.job_date)} · {row.job_type}
                  </span>
                </div>
                {row.comment && <p className="mt-1.5 text-sm text-slate-700">“{row.comment}”</p>}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MyRatingCard;
